export default "__VITE_ASSET__DAGtw9bZ__"